import React from 'react';
import { Modal, Button, Form, Row, Col } from 'antd';
import { _setAxios } from 'lib/Helper';
import { SelectSemester, SelectTahunAjaran } from 'components/select';

class ModalFilter extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            values: {},
            errors: {},
            loading: false,
            ddl: {
                rombels: []
            }
        };
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;

        this.setState({
            values: values,
        });
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    getRombelDDL = () => {
        _setAxios("rombel/dropdown", "POST", {
            "pagination": {
                "current": 1,
                "pageSize": 10,
            },
            "search": "",
            "sorting": []
        }).then(resp => {
            if (resp.status === true) {
                this.setState({
                    ddl: {
                        ...this.state.ddl,
                        rombels: resp.data.list
                    },
                })
            }
        })
    }

    componentDidMount() {
        this.getRombelDDL()
    }

    render() {
        const { values } = this.props

        console.log("values", values);

        return (
            <Modal
                title="Filter"
                width={300}
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                footer={<>
                    <Button onClick={this.props.hideModal}>Tutup</Button>
                    <Button type='primary' onClick={this.props.setTableFilterFromTemp}>Terapkan</Button>
                </>}
            >
                <Form
                    name="basic"
                    autoComplete="off"
                    layout="vertical"
                >
                    <Row gutter={[16, 16]}>
                        <Col xs={24}>
                            <Form.Item label={<>Tahun Ajaran <span style={{ color: 'red' }}>*</span></>}>
                                <SelectTahunAjaran
                                    allowClear
                                    initialValue={values.tahun_ajaran_id}
                                    value={values.tahun_ajaran_id}
                                    onChange={(val) => {
                                        this.props.setTempTableFilter("tahun_ajaran_id", val || null);
                                        this.props.setTempTableFilter("semester_id", null);
                                    }}
                                />
                            </Form.Item>
                            <Form.Item label={<>Semester <span style={{ color: 'red' }}>*</span></>}>
                                <SelectSemester
                                    allowClear
                                    value={values.semester_id}
                                    tahunAjaranId={values.tahun_ajaran_id}
                                    disabled={!values.tahun_ajaran_id}
                                    onChange={(val) => {
                                        this.props.setTempTableFilter("semester_id", val || null);
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form >
            </Modal >
        )
    }
}

export default ModalFilter;
